import { QueryClient } from "@tanstack/react-query";

/**
 * Cache policy contract — see docs/perf-cache-policy.md.
 *
 * The portal hits a PocketBase backend backed by SQLite; every refetch is
 * potentially a sort over hundreds of thousands of rows, so we minimize
 * background refetching and rely on explicit invalidation from mutations.
 *
 *   staleTime: 30s    — data is considered fresh for 30 seconds; mounts
 *                       within that window hit cache, not network.
 *   gcTime: 5 min     — unused query data evicted after 5 minutes idle.
 *   refetchOnWindowFocus: false — tab focus does NOT re-fire queries.
 *                                 Stale list pages will not silently
 *                                 self-update; rely on user navigation /
 *                                 explicit refresh.
 *   refetchOnReconnect: false   — network reconnect does NOT re-fire
 *                                 queries either. Same rationale.
 *   retry: 1          — single retry on failure; PB errors are usually
 *                       deterministic (404, 401, validation).
 *
 * Override these defaults per-query ONLY for genuinely real-time surfaces
 * (notifications, live counters). Avoid `refetchInterval` entirely —
 * mutations should invalidate the relevant query keys instead.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
